<template>
  <v-card flat>
    <v-card-text class="d-flex">
      <v-avatar
        rounded
        size="120"
        class="me-6"
      >
        <v-img :src="logoEmpresa"></v-img>
      </v-avatar>

      <!-- upload photo -->
      <div class="d-flex flex-column align-center justify-center">
        <div class="d-flex flex-wrap align-center justify-center">
          <v-btn
            color="primary"
            class="mx-3 mt-3 p-0"
            @click="inputLogoEmpresaRef.click()"
          >
            <span class="d-sm-inline d-none p-0 m-0">Upload do logo da empresa</span>
            <span class="d-sm-none d-block p-0 m-0">Upload do logo</span>
          </v-btn>

          <input
            ref="inputLogoEmpresaRef"
            type="file"
            accept=".png, .jpg, .jpeg"
            :hidden="true"
            @change="parseFotoUpload"
            @click="resetInput"
          />

          <v-btn
            v-if="accountDataLocale.fotoDataUrl"
            color="error"
            outlined
            class="mt-3"
            @click="descartarFotoUpload"
          >
            <span>Descartar</span>
          </v-btn>
        </div>

        <p class="d-sm-block d-none text-sm text-center mt-5">
          <span class="d-md-inline d-none">Formato PNG, JPG ou JPEG.</span> Tamanho máximo de 1MB.
        </p>
      </div>
    </v-card-text>

    <p class="d-sm-none d-block text-sm text-center mt-4 mb-7">
      Formato PNG, JPG ou JPEG. Tamanho máximo de 1MB.
    </p>

    <v-card-text>
      <v-form
        ref="form"
        v-model="valid"
        @submit.prevent="onSubmit"
      >
        <v-row class="mt-3">
          <v-col
            cols="12"
            md="4"
          >
            <v-text-field
              v-model="accountDataLocale.cpfCnpj"
              v-mask="['##.###.###/####-##']"
              label="CNPJ"
              dense
              outlined
              :rules="[validators.required]"
            ></v-text-field>
          </v-col>

          <v-col
            md="8"
            cols="12"
          >
            <v-text-field
              v-model="accountDataLocale.nome"
              label="Nome da empresa"
              :hint="`Máximo de 50 caracteres`"
              :maxlength="50"
              dense
              outlined
              :rules="[validators.required]"
            ></v-text-field>
          </v-col>

          <v-col
            md="4"
            cols="12"
          >
            <v-text-field
              label="Razão Social"
              :hint="`Máximo de 50 caracteres`"
              :maxlength="50"
              dense
              outlined
              :rules="[validators.required]"
            ></v-text-field>
          </v-col>

          <v-col
            md="8"
            cols="12"
          >
            <v-text-field
              v-model="accountDataLocale.sobrenome"
              label="Nome do responsável"
              :hint="`Máximo de 50 caracteres`"
              :maxlength="50"
              dense
              outlined
              :rules="[validators.required]"
            ></v-text-field>
          </v-col>

          <v-col
            md="2"
            cols="12"
          >
            <v-text-field
              v-model="accountDataLocale.telefones[0].numero"
              v-mask="'(##) #####-####'"
              label="Telefone"
              dense
              outlined
              :rules="[validators.required]"
            ></v-text-field>
          </v-col>

          <v-col
            md="3"
            cols="12"
          >
            <v-text-field
              v-model="accountDataLocale.telefones[0].ramal"
              label="Ramal"
              dense
              outlined
            ></v-text-field>
          </v-col>

          <v-checkbox
            v-model="accountDataLocale.telefones[0].tipoContato"
            class="mx-4"
            input-value="true"
            value="WhatsApp"
            label="WhatsApp"
          ></v-checkbox>

          <v-checkbox
            v-model="accountDataLocale.telefones[0].tipoContato"
            value="Telegram"
            label="Telegram"
          ></v-checkbox>

          <v-col
            cols="12"
          >
            <div class="d-flex justify-space-between">
              <v-btn
                color="secondary"
                outlined
                type="reset"
                class="px-8"
                @click.prevent="resetForm"
              >
                Cancelar
              </v-btn>
              <v-btn
                color="primary"
                class="px-8"
                type="submit"
              >
                <v-progress-circular
                  v-if="loading"
                  class="mx-6"
                  indeterminate
                  color="secundary"
                ></v-progress-circular>
                <span v-else>Avançar</span>
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import Vue from 'vue'
import { ref } from '@vue/composition-api'
import { mdiAlertOutline, mdiCloudUploadOutline } from '@mdi/js'
import { required } from '@core/utils/validation'
import { isTelefoneCelularValido, isTelefoneFixoValido, isCnpjValido } from '@/utils/validation'
import ColaboradorService from '@/services/modules/ColaboradorService'

export default {
  props: {
    accountData: {
      type: Object,
      default: () => {},
    },
  },

  setup(props, { emit }) {
    const valid = ref(false)
    const form = ref(null)

    const validate = () => {
      form.value.validate()
    }
    const loading = ref(false)

    const inputLogoEmpresaRef = ref(null)
    const logoEmpresa = ref(require('@/assets/images/avatars/avatar_user.png'))
    const antigoLogoEmpresa = ref(logoEmpresa.value)

    const accountDataLocale = ref(JSON.parse(JSON.stringify(props.accountData)))

    const resetForm = () => {
      accountDataLocale.value = props.accountData
      emit('voltarhandleStepInfo')
    }

    const descartarFotoUpload = () => {
      accountDataLocale.value.fotoDataUrl = undefined
      logoEmpresa.value = antigoLogoEmpresa.value
    }

    const resetInput = () => {
      inputLogoEmpresaRef.value.value = null
    }

    const parseFotoUpload = e => {
      const file = e.target.files[0]
      const reader = new FileReader()
      reader.onloadend = () => {
        const dataUrl = reader.result
        const tamanhoImagemEmMB = new Blob([dataUrl]).size / 1_048_576

        if (tamanhoImagemEmMB > 1) {
          Vue.$toast.error('A imagem não pode ter mais de 1MB.', {
            timeout: false,
          })
        } else {
          accountDataLocale.value.fotoDataUrl = dataUrl
          logoEmpresa.value = dataUrl
        }
      }
      reader.readAsDataURL(file)
    }

    const onSubmit = () => {
      loading.value = true

      if (valid.value) {
        ColaboradorService
          .update(accountDataLocale.value)
          .then(() => {
            setTimeout(() => {
              loading.value = false
            }, 1000)
            emit('refresh-data')
            emit('handleStepValidation')
          })
          .catch(() => {
            loading.value = false
          })
      } else {
        loading.value = false
        validate()
      }
    }

    return {
      inputLogoEmpresaRef,
      logoEmpresa,
      onSubmit,
      accountDataLocale,
      resetForm,
      valid,
      form,
      validate,
      loading,
      resetInput,
      descartarFotoUpload,
      parseFotoUpload,
      icons: {
        mdiAlertOutline,
        mdiCloudUploadOutline,
      },
      validators: {
        required,
        isCnpjValido,
        isTelefoneCelularValido,
        isTelefoneFixoValido,
      },
    }
  },
}
</script>
